import { SkeletonRectangle, Box, SkeletonGroup } from '@wix/design-system';
import React from 'react';
import { useSiteContext } from '@wix/app-market-core';

export function CollectionHeaderSkeleton() {
  const { horizontalNav } = useSiteContext();

  return (
    <SkeletonGroup skin="light">
      <Box
        dataHook="skeleton-header"
        marginTop={horizontalNav ? undefined : '24px'}
        direction="vertical"
      >
        <Box dataHook="skeleton-titles" direction="vertical">
          <SkeletonRectangle width="175px" height="18px" />
          <SkeletonRectangle width="638px" height="30px" marginTop="6px" />
        </Box>
      </Box>
    </SkeletonGroup>
  );
}
